import styles from "../../styles/Form.module.css";
import classNames from "classnames";

interface SelectProps {
  autoComplete?: string;
  blankName?: string;
  className?: string;
  disabled?: boolean;
  fieldName?: string;
  inError?: boolean;
  onBlur: () => void;
  onChange: (newValue: string | number) => void;
  required?: boolean; // Not implemented
  value?: string | number;
  values:
    | string[]
    | number[]
    | Record<string, string | number>
    | be.FieldValue[];
}

function Select({
  autoComplete = "",
  blankName,
  className,
  disabled = false,
  fieldName = "",
  inError,
  onBlur,
  onChange,
  required,
  value,
  values,
}: SelectProps): JSX.Element {
  // Create value object.
  let valueMap: Map<string, string | number>;
  if (Array.isArray(values)) {
    if (typeof values[0] === "object" && "field" in values[0]) {
      // Is a be.FieldValue
      let entries: [string, string][] = (values as be.FieldValue[]).map(
        (v: be.FieldValue) => [v.field || String(v.value), String(v.value)],
      );
      valueMap = new Map(entries);
    } else {
      valueMap = new Map(values.map((v) => [String(v), String(v)]));
    }
  } else {
    valueMap = new Map(Object.entries(values));
  }

  return (
    <select
      autoComplete={autoComplete}
      name={fieldName}
      disabled={disabled}
      className={classNames(
        styles.select,
        className,
        { [styles.error]: inError },
        inError ? "placeholder-red-900/50" : "placeholder-gray-500/50",
        "self-end block pl-3 pr-10 py-2 text-base border-gray-400 rounded-md w-auto",
      )}
      onBlur={onBlur}
      onChange={(e) => onChange(e.currentTarget.value)}
      value={value}
    >
      {blankName && (
        <option key="blank" value="-">
          {blankName}
        </option>
      )}
      {Array.from(valueMap, ([label, value]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
}

export default Select;
